/*
 * Copyright (C) 2016 - 2024 Vivien Pelenc / CEFE / CNRS
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */


import React, {useEffect, useRef, useState} from 'react';
import Chart from 'chart.js/auto';
import {
    getCumul,
    getCumulAnnuel,
    getCumulJournalier,
    getCumulMensuel, getDonneHoraireDate,
    getDonneJournalierDate,
    getDonneMensuelleDate,
    getDonneTelechargementDate
} from "../ConnectionBDD";

export default function ChartCumulDynamiqueTotal() {
    const unite = 'mm';
    const [cumulData, setCumulData] = useState([]);
    const [labels, setLabels] = useState([]);
    const [depth, setDepth] = useState(0);
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [day, setDay] = useState(new Date().getDay());

    useEffect(() => {
        const fetchData = async () => {
            try {
                //console.log("depth : "+depth);
                let response;
                switch(depth) {
                    case 0:

                        response = await getCumul();

                        //console.log("1 : "+response);

                        setCumulData(Object.values(response).map(value => value));
                        setLabels(['Jour', 'Mois', 'Année']);
                        break;
                    case 3:
                        //anné actuelle
                        var y = new Date().getFullYear();
                        response = await getDonneMensuelleDate('01/01/'+y, '31/12/'+y);



                        //console.log("2 : "+response);

                        setCumulData(Object.values(response).map(value => value.cumulativeRainMonth));
                        setLabels(Object.values(response).map(value => `${value.month}/${value.year}`));

                        break;
                    case 2:
                        var y2 = new Date().getFullYear();
                        var m = new Date().getMonth() + 1;

                        response = await getDonneJournalierDate('01/'+m+'/'+y2, '31/'+m+'/'+y2);


                        setCumulData(Object.values(response).map(value => value.cumulativeRainDay));
                        setLabels(Object.values(response).map(value => new Date(value.date).getDate()+'/'+(new Date(value.date).getMonth()+1)+'/'+new Date(value.date).getFullYear()));
                        break;
                    case 1:

                        var y3 = new Date().getFullYear();
                        var m2 = new Date().getMonth() + 1;
                        var d = new Date().getDate();
                        console.log(d + '/' + m2 + '/' + y3);
                        response = await getDonneHoraireDate(d + '/' + m2 + '/' + y3, d + '/' + m2 + '/' + y3);
                        console.log(response);



// Fonction de comparaison pour trier par heure
                    function compareByTime(a, b) {
                        const timeA = new Date(`1970-01-01T${a.time}Z`); // Supposons que le temps soit au format HH:MM
                        const timeB = new Date(`1970-01-01T${b.time}Z`);
                        return timeA - timeB;
                    }


                    const sortedResponse = Object.values(response).sort(compareByTime);


                        setCumulData(sortedResponse.map(value => Number(value.cumulativeRain.toFixed(1))));



                        setLabels(sortedResponse.map(value => `${value.time}`));

                        //console.log(sortedResponse);

                    break;
                default:
                    break;
                }
            } catch (error) {
                console.error('Erreur lors de la récupération des données de cumul:', error);
            }
        };

        fetchData();

        const refreshData = setInterval(() => {
            const currentDate = new Date();
            const minutes = currentDate.getMinutes();
            if (minutes === 1 || minutes === 31) {
                fetchData();
            }
        }, 59000);

        return () => clearInterval(refreshData);
    }, [depth]);

    return (
        <div>
            <Graph labels={labels} data={cumulData} unite={unite} depth={depth} setDepth={setDepth} setYear={setYear} setMonth={setMonth} setDay={setDay}/>
        </div>
    );
}

function Graph({ labels, data, unite, depth, setDepth, setYear, setMonth, setDay}) {
    const canvasRef = useRef(null);
    const chartRef = useRef(null);


    useEffect(() => {
        //arround data to 1 decimal place
        data = data.map(value => Number(value.toFixed(1)));

        if (canvasRef.current) {
            if (chartRef.current) {
                chartRef.current.destroy();
            }
            const ctx = canvasRef.current.getContext('2d');
            chartRef.current = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: labels,
                    datasets: [{
                        label: unite,
                        data: data,
                        backgroundColor: 'rgb(59,96,227)',
                    }]
                },
                options: {

                    interaction: {
                        mode: 'index',
                        intersect: false
                    },

                    scales: {
                        y: {
                            beginAtZero: true,
                            ticks: {
                                callback: function(value) {
                                    return value + ' mm'; // Ajoute un pourcentage après chaque valeur
                                }
                            }
                        }
                    },
                    plugins: {
                        title: {
                            display: true,
                            text: `Cumul Précipitations ${depth === 0 ? '' : depth === 1 ? 'Horaire' : depth === 2 ? 'Journalier' : 'Mensuel'} (en mm)`,
                        },
                        legend: {
                            display: false
                        },
                        tooltip: {
                            mode: 'index',
                            intersect: false
                        }


                    },
                    onClick: (e, activeEls) => {
                        if (activeEls.length > 0) {
                            console.log(activeEls[0].index);
                            if (depth === 0) {
                                setDepth(prevDepth => (activeEls[0].index + 1));
                                if (depth === 0) {
                                    setYear(labels[activeEls[0].index]);
                                }
                                if (depth === 1) {
                                    var m = labels[activeEls[0].index].split('/')[0]
                                    setMonth(m);
                                }
                                if (depth === 2) {
                                    var d = labels[activeEls[0].index].split('/')[0]
                                    setDay(d);
                                }
                            }
                        }
                    }
                }
            });
        }
    }, [labels, data, depth, setDepth, setYear, setMonth, setDay]);


    if (depth === 0) {
        return <div>
            <canvas id="graphique" ref={canvasRef} width="100" height="100"></canvas>
        </div>;
    }
    return <div>
        <canvas id="graphique" ref={canvasRef} width="100" height="100"></canvas>
        {depth !== 0 && <button onClick={() => setDepth(0)}>Réinitialiser</button>}
        <p/>
    </div>;
}

